<!-- 组件说明 -->
<template>
    <el-dialog
        :title="title"
        :custom-class="'check-ranking-query-detail'"
        :visible.sync="dialogVisible"
        width="1200px"
        append-to-body
        :before-close="beforeClose"
        :fullscreen="true"
    >
        <div class="check-detail-box">
            <div class="dfcjsb">
                <el-select v-if="queryType === 3" @change="search" v-model="keyword" class="w220" size="small">
                    <el-option
                        v-for="(item, index) in keywordList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
                <span style="width: 100%" class="tr">查询时间：{{ searchTime }}</span>
            </div>
            <div class="tableView mt20" v-loading="loading">
                <div class="table">
                    <el-table
                        :data="tableData"
                        stripe
                        style="width: 100%"
                        :header-cell-style="tableHeader"
                        height="100%"
                        empty-text="未查到相关数据"
                    >
                        <el-table-column label="关键词" width="120">
                            <template #default="{ row }">
                                <span class="textOver" :title="row.keyword">{{ row.keyword }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="商品信息" width="540">
                            <template #default="{ row }">
                                <div class="dfc" v-if="row.ProductInfo">
                                    <el-image
                                        fit="contain"
                                        :src="row.ProductInfo.Image.images[0] | alicdnFormat"
                                        style="max-width: 64px; max-height: 64px"
                                    />
                                    <span class="ml10">
                                        <a
                                            style="width: 64px"
                                            :href="`https://detail.1688.com/offer/${row.offerId}.html?token=${token}`"
                                            target="_blank"
                                        >
                                            <span v-html="row.title"></span>
                                        </a>
                                        <p class="mt10 color99">
                                            更新时间：{{ row.ProductInfo.LastUpdateTime | formatTime }}
                                        </p>
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="公司名称" v-if="queryType === 1">
                            <template #default="{ row }">
                                <span>{{ row.companyName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="企业实力" v-if="queryType === 3">
                            <template #default="{ row }">
                                <span class="dfc">
                                    <img
                                        v-if="row.shilitag"
                                        :src="`${domain}tools/dzPopup/icon/strengthIcon.png`"
                                        style="vertical-align: middle"
                                    /><img
                                        :src="`${domain}tools/dzPopup/icon/chengIcon.png`"
                                        class="ml5"
                                        style="vertical-align: middle"
                                    />
                                    <span class="ml5">
                                        {{ row.companyTag }}
                                    </span>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="90天成交额" prop="tradeBt" />
                        <el-table-column label="排名位置" align="center" header-align="center" width="115">
                            <template #default="{ row }">
                                <p>
                                    第<em style="color: #ff9000">{{ row.pageIndex }}</em
                                    >个
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="类型" align="center" header-align="center" width="80" prop="type" />
                    </el-table>
                </div>

                <div class="tr mt10 pagination">
                    <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        background
                        layout="prev, pager, next,total, jumper"
                        :total="query.totalCount"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import dayjs from 'dayjs';
import config from '@packages/common/config.js';
import { alicdnFormat } from '@packages/modules/manualIdentify/common/identifyCommon';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    filters: {
        formatTime(val) {
            if (val === '' || val === null || val === undefined) {
                return '';
            }
            return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
        },
        alicdnFormat,
    },
    data() {
        return {
            dialogVisible: false,
            title: '',
            query: {
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
            },
            queryType: 1,
            keyword: '',
            keywordList: [],
            searchTime: '',
            tableData: [],
            loading: false,
            tableHeader: {
                background: '#f4f4f4',
                color: '#4c4b4b',
                fontSize: '14px',
                fontWeight: 'normal',
            },
            domain: config.ossUiDomainUrl,
            token: '',
            taskId: '',
        };
    },
    //监控data中的数据变化
    watch: {},
    //监听属性 类似于data概念
    computed: {},
    methods: {
        show(data) {
            this.keyword = '';
            this.title =
                data.queryType === 1
                    ? '全店产品排名_查看详情'
                    : data.queryType === 2
                    ? '单产品排名-查看详情'
                    : '关键词排名-查看详情';
            this.queryType = data.queryType;
            this.keywordList = data.keyWords.map((el) => {
                return {
                    label: el,
                    value: el,
                };
            });
            this.taskId = data.id;
            this.searchTime = dayjs(data.createTime).format('YYYY-MM-DD HH:mm:ss');
            this.getDetails();
            this.dialogVisible = true;
        },

        handleCurrentChange(index) {
            this.query.pageIndex = index;
            this.getDetails();
        },

        search() {
            this.query.pageIndex = 1;
            this.getDetails();
        },

        getDetails() {
            let {
                query: { pageIndex, pageSize },
                taskId,
            } = this;
            let ajaxData = {
                pageIndex,
                pageSize,
                taskId,
            };
            if (this.keyword) {
                ajaxData.keyword = this.keyword;
            }
            this.loading = true;
            this.$ajax.post('fw/api/v1/RankedQuery/SearchRankedQueryDetails', ajaxData).then((res) => {
                this.loading = false;
                let { code, msg, result } = res;
                if (code !== 200) {
                    return this.$message.warning(msg);
                }
                let tableData = result.list.map((item) => {
                    return {
                        keyword: item.keyWord, // 关键词
                        ProductInfo: {
                            Image: {
                                images: [''],
                            },
                        },
                        title: item.title.replace(
                            item.keyword,
                            '<font style="color: red;">' + item.keyWord + '</font>'
                        ), // 产品标题
                        shilitag: item.power, // 实力商家
                        companyTag: item.tpYearNum + '年', // 诚信通年限
                        tradeBt: item.gmvPrice30d ? item.gmvPrice30d : '-', // 30天成交额
                        type: item.isP4P ? '网销宝' : '自然搜索',
                        pageIndex: item.order, // 第几个
                        offerId: item.offerId,
                        companyName: item.companyName,
                    };
                });
                let ids = tableData.map((el) => el.offerId);
                this.tableData = tableData;
                this.query.totalCount = result.totalCount;

                this.getoffers(ids);
            });
        },

        getoffers(ids) {
            if (!ids.length) {
                return;
            }
            this.$ajax
                .post('app/so/getoffers', {
                    offerIds: ids,
                })
                .then((res) => {
                    if (!res) {
                        return;
                    }
                    this.tableData.forEach((el) => {
                        const production = res[el.offerId];
                        el.ProductInfo = {
                            ProductId: production?.ProductInfo?.ProductId,
                            Image: production?.ProductInfo?.Image,
                            LastUpdateTime: production?.LastUpdateTime,
                        };
                    });
                });
        },

        beforeClose() {
            this.dialogVisible = false;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // 目前 商机助理，排名优化_排名查询_竞品分析，大泽云ERP智慧版(档口)，店长工具，慧眼识货标准版 在用
        this.token = localStorage.getItem('accessToken') || localStorage.getItem('sjzlAccessToken');
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
};
</script>

<style lang="scss">
//@import url()
.check-ranking-query-detail {
    width: 1200px !important;
    height: calc(100% - 80px) !important;
    margin: 40px auto !important;
    .el-dialog__body {
        height: calc(100% - 34px);
        .check-detail-box {
            height: 100%;
            .tableView {
                height: calc(100% - 52px);
                .table {
                    height: calc(100% - 32px);
                }
            }
        }
    }
}
</style>
